/* Custom Build Configurator — Fox's Chandlery
   Reads the config JSON emitted by sections/custom-build.liquid.
   All data (ropes, service prices, service variant IDs, help copy) comes from
   Shopify. Nothing is hardcoded here except presentation.

   Flow: what are you making? -> which rope -> size -> length -> ends -> extras
   -> finished-line preview. The first two choices drive everything else: the
   job filters both the rope list (product metafield `suitable_for`) and the
   services (metaobject `applies_to`), and the rope decides diameters, colours
   and splice price band.

   Prices are never duplicated. Rope prices come from the rope variant; splice
   and accessory prices from their own product variants. Nothing here invents
   a number. */
(function () {
  'use strict';

  var COLOURS = {
    white: '#F2F2EE', black: '#25282C', silver: '#B9BEC4', grey: '#9AA3AB', gray: '#9AA3AB',
    red: '#C0392B', blue: '#2C5F9E', navy: '#12305C', green: '#2E7D4F', yellow: '#D9B93C',
    orange: '#D97A2B', gold: '#C8A93C', purple: '#6B4C9A', pink: '#C86A8E', beige: '#D8CBB0',
    buff: '#D8CBB0', trace: null, fleck: null
  };

  function colourOf(name) {
    var parts = String(name || '').toLowerCase().replace(/fleck|small|no\b/g, '').split(/[\/ ]+/).filter(Boolean);
    var hits = [];
    parts.forEach(function (p) { if (COLOURS[p]) hits.push(COLOURS[p]); });
    if (!hits.length) return { css: '#9AA3AB', solid: '#9AA3AB' };
    if (hits.length === 1) return { css: hits[0], solid: hits[0] };
    return {
      css: 'repeating-linear-gradient(135deg,' + hits[0] + ' 0 8px,' + hits[1] + ' 8px 14px)',
      solid: hits[1]
    };
  }

  function money(n) { return '£' + Number(n).toFixed(2); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- illustrations ---------- */
  function shade(hex, amt) {
    var h = String(hex).replace('#', '');
    if (h.length === 3) h = h.split('').map(function (x) { return x + x; }).join('');
    var n = parseInt(h, 16), cl = function (v) { return Math.max(0, Math.min(255, v)); };
    var r = cl((n >> 16) + amt), g = cl(((n >> 8) & 255) + amt), b = cl((n & 255) + amt);
    return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  }

  function art(code, col, uid) {
    var c = col || '#2C5F9E', dark = shade(c, -28), light = shade(c, 22);
    var w = 'cbw2-' + uid, s = 'cbs2-' + uid, st = 'cbst-' + uid, ny = 'cbny-' + uid;
    var defs = '<defs>' +
      '<pattern id="' + w + '" width="11" height="11" patternUnits="userSpaceOnUse" patternTransform="rotate(35)">' +
      '<path d="M0 5.5 H11" stroke="rgba(0,0,0,.17)" stroke-width="2.6"/></pattern>' +
      '<linearGradient id="' + s + '" x1="0" y1="0" x2="0" y2="1">' +
      '<stop offset="0%" stop-color="#fff" stop-opacity=".5"/><stop offset="50%" stop-color="#fff" stop-opacity="0"/>' +
      '<stop offset="100%" stop-color="#000" stop-opacity=".2"/></linearGradient>' +
      '<linearGradient id="' + st + '" x1="0" y1="0" x2="0" y2="1">' +
      '<stop offset="0%" stop-color="#FDFEFF"/><stop offset="32%" stop-color="#C3CDD8"/>' +
      '<stop offset="52%" stop-color="#78838F"/><stop offset="70%" stop-color="#AAB5C0"/>' +
      '<stop offset="100%" stop-color="#E4EAF0"/></linearGradient>' +
      '<linearGradient id="' + ny + '" x1="0" y1="0" x2="0" y2="1">' +
      '<stop offset="0%" stop-color="#FCFCFB"/><stop offset="100%" stop-color="#D6D6CE"/></linearGradient></defs>';

    function run(x) {
      return '<rect x="' + x + '" y="44" width="' + (210 - x) + '" height="15" rx="7.5" fill="' + c + '"/>' +
             '<rect x="' + x + '" y="44" width="' + (210 - x) + '" height="15" rx="7.5" fill="url(#' + w + ')"/>' +
             '<rect x="' + x + '" y="44" width="' + (210 - x) + '" height="15" rx="7.5" fill="url(#' + s + ')"/>';
    }
    function eye(cx, rx, ry) {
      return '<ellipse cx="' + cx + '" cy="51.5" rx="' + rx + '" ry="' + ry + '" fill="none" stroke="' + c + '" stroke-width="15"/>' +
             '<ellipse cx="' + cx + '" cy="51.5" rx="' + rx + '" ry="' + ry + '" fill="none" stroke="url(#' + w + ')" stroke-width="15"/>';
    }
    /* A thimble is a teardrop, not a ring: the point sits where the rope legs
       converge into the splice, the bulb takes the load. */
    var DROP_ROPE = 'M66 51.5 C58 36 46 30.5 32 30.5 C18 30.5 11 40 11 51.5 C11 63 18 72.5 32 72.5 C46 72.5 58 67 66 51.5 Z';
    var DROP_THIM = 'M55 51.5 C49 42 41 38.5 33 38.5 C25 38.5 21 44.5 21 51.5 C21 58.5 25 64.5 33 64.5 C41 64.5 49 61 55 51.5 Z';
    function dropEye() {
      return '<path d="' + DROP_ROPE + '" fill="none" stroke="' + c + '" stroke-width="15"/>' +
             '<path d="' + DROP_ROPE + '" fill="none" stroke="url(#' + w + ')" stroke-width="15"/>';
    }
    function bands(x, n, bw, bc) {
      n = n || 3; bw = bw || 4; bc = bc || '#E8DFC8';
      var o = '';
      for (var i = 0; i < n; i++) {
        o += '<rect x="' + (x + i * (bw + 2.5)) + '" y="42.5" width="' + bw + '" height="18" rx="1.6" fill="' + bc +
             '" stroke="rgba(0,0,0,.18)" stroke-width=".6"/>';
      }
      return o;
    }

    var A = {
      heatseal: run(30) + '<rect x="28" y="44" width="7" height="15" rx="3.5" fill="' + dark + '"/>' +
                          '<rect x="26" y="42" width="4" height="19" rx="2" fill="#2A2A2A" opacity=".75"/>',
      whip: run(26) + bands(31),
      whiptail: run(62) + bands(67) +
        '<path d="M62 51.5 C50 51.5 40 49 22 47.5" stroke="' + light + '" stroke-width="7" fill="none" stroke-linecap="round"/>' +
        '<path d="M62 51.5 C50 51.5 40 49 22 47.5" stroke="url(#' + w + ')" stroke-width="7" fill="none" stroke-linecap="round"/>',
      backsplice: run(56) +
        '<path d="M60 44 C44 37.5 28 41 22 51.5 C28 62 44 65.5 60 59 Z" fill="' + c + '"/>' +
        '<path d="M60 44 C44 37.5 28 41 22 51.5 C28 62 44 65.5 60 59 Z" fill="url(#' + w + ')"/>' +
        '<path d="M52 40.5 L50 62.5 M42 38.5 L41 64.5 M32 40.5 L31 62.5" stroke="rgba(0,0,0,.26)" stroke-width="2" stroke-linecap="round"/>',
      eye30: run(64) + eye(42, 20, 18) + bands(62, 2),
      eye120: run(86) + eye(50, 32, 26) + bands(84, 2),
      eyenyl: run(70) + dropEye() + bands(68, 2) +
        '<path d="' + DROP_THIM + '" fill="none" stroke="#23272C" stroke-width="10.5" stroke-linejoin="round"/>' +
        '<path d="' + DROP_THIM + '" fill="none" stroke="url(#' + ny + ')" stroke-width="4.5" opacity=".22"/>',
      eyess: run(70) + dropEye() + bands(68, 2) +
        '<path d="' + DROP_THIM + '" fill="none" stroke="#6C7885" stroke-width="8.4" stroke-linejoin="round"/>' +
        '<path d="' + DROP_THIM + '" fill="none" stroke="url(#' + st + ')" stroke-width="7" stroke-linejoin="round"/>' +
        '<path d="M52 47 C46 41 40 39.5 33 39.5 C26 39.5 23 43.5 22.5 48" fill="none" stroke="#fff" stroke-width="1.9" opacity=".9" stroke-linecap="round"/>',
      eyesnap: run(74) + eye(56, 15, 14) + bands(72, 2) +
        '<rect x="20" y="41" width="30" height="21" rx="6" fill="url(#' + st + ')" stroke="#7C8794" stroke-width=".9"/>' +
        '<path d="M26 41 C26 30 44 30 44 41" fill="none" stroke="url(#' + st + ')" stroke-width="6"/>' +
        '<circle cx="35" cy="51.5" r="4" fill="#6E7A88"/>' +
        '<rect x="12" y="46" width="10" height="11" rx="3" fill="url(#' + st + ')" stroke="#7C8794" stroke-width=".9"/>',
      chafe: run(0) + '<rect x="70" y="40" width="70" height="23" rx="11" fill="#8A939E"/>' +
        '<rect x="70" y="40" width="70" height="23" rx="11" fill="url(#' + w + ')"/>' +
        '<path d="M72 40.5 L72 62.5 M138 40.5 L138 62.5" stroke="#E8DFC8" stroke-width="2.5"/>',
      hose: run(0) + '<rect x="70" y="38" width="70" height="27" rx="13" fill="#CFE0EA" opacity=".82" stroke="#9FB6C4" stroke-width="1.2"/>' +
        '<path d="M78 38.5 L78 64.5 M92 38.5 L92 64.5 M106 38.5 L106 64.5 M120 38.5 L120 64.5 M134 38.5 L134 64.5" stroke="#9FB6C4" stroke-width="1" opacity=".6"/>',
      taper: '<path d="M210 44 L96 44 C74 44 60 47.5 34 49.5 L34 53.5 C60 55.5 74 59 96 59 L210 59 Z" fill="' + c + '"/>' +
        '<path d="M210 44 L96 44 C74 44 60 47.5 34 49.5 L34 53.5 C60 55.5 74 59 96 59 L210 59 Z" fill="url(#' + w + ')"/>',
      loop250: run(104) + eye(60, 44, 30) + bands(102, 2),
      loop250web: run(104) + eye(60, 44, 30) + bands(102, 2) +
        '<path d="M20 33 C6 42 6 61 20 70" fill="none" stroke="#3B3B3B" stroke-width="17" stroke-linecap="round"/>' +
        '<path d="M20 33 C6 42 6 61 20 70" fill="none" stroke="rgba(255,255,255,.13)" stroke-width="17" stroke-linecap="round"/>' +
        '<path d="M17 36.5 L17 66.5 M25 34 L25 69" stroke="rgba(0,0,0,.35)" stroke-width="1.6"/>',
      snubber: run(0) +
        '<rect x="66" y="31" width="80" height="41" rx="15" fill="#2A2E33"/>' +
        '<rect x="66" y="31" width="80" height="41" rx="15" fill="url(#' + s + ')" opacity=".55"/>' +
        '<rect x="58" y="44.5" width="96" height="14" rx="7" fill="' + c + '"/>' +
        '<rect x="58" y="44.5" width="96" height="14" rx="7" fill="url(#' + w + ')"/>' +
        '<path d="M82 33 L82 70 M130 33 L130 70" stroke="rgba(255,255,255,.13)" stroke-width="2.5"/>',
      colmark: run(0) + bands(60, 3, 5, '#C8342E') + bands(96, 3, 5, '#D9B93C') + bands(132, 3, 5, '#2F7D4F')
    };
    return '<svg viewBox="0 16 210 72" preserveAspectRatio="xMidYMid meet">' + defs + (A[code] || run(0)) + '</svg>';
  }

  /* ---------- one configurator instance ---------- */
  function init(root) {
    var cfgEl = root.querySelector('[data-cb-config]');
    if (!cfgEl) return;
    var CFG;
    try { CFG = JSON.parse(cfgEl.textContent); }
    catch (e) { console.error('[custom-build] config JSON failed to parse', e); return; }

    var uid = root.id.replace(/[^a-z0-9]/gi, '');
    var SET = CFG.settings;
    if (getComputedStyle(root).position === 'static') root.style.position = 'relative';

    /* ---------- ropes ----------
       One page can carry a whole range. Each rope brings its own diameters,
       colours and (optionally) a splice price band via `cls`. Ropes with no
       colour option are normal — most mooring lines come one colour only. */

    /* Option names are not consistent across the catalogue: most ropes use
       "Rope Diameter" / "Rope Colour", but some use "Diameter", "Size",
       "Colour" or the US "Color". Match the configured name first, then fall
       back to a keyword match, so a rope is never silently dropped or shown
       without its colours because of a naming difference. */
    function findOpt(names, exact, words) {
      var i = names.indexOf(exact);
      if (i !== -1) return i;
      for (i = 0; i < names.length; i++) {
        var n = String(names[i]).toLowerCase();
        for (var k = 0; k < words.length; k++) if (n.indexOf(words[k]) !== -1) return i;
      }
      return -1;
    }
    function normaliseRope(r) {
      var oN = r.variants.length ? r.variants[0].optNames : [];
      var diaIdx = findOpt(oN, SET.diaOption, ['diameter', 'size']);
      var colIdx = findOpt(oN, SET.colOption, ['colour', 'color']);
      var vs = r.variants.map(function (v) {
        var d = diaIdx >= 0 ? v.opts[diaIdx] : v.opts[0];
        var c = colIdx >= 0 ? v.opts[colIdx] : '';
        return {
          id: v.id, sku: v.sku, price: Number(v.price), stock: Number(v.stock) || 0,
          available: !!v.available, dia: parseFloat(String(d)), colour: c, hex: colourOf(c)
        };
      }).filter(function (v) { return !isNaN(v.dia); });
      return {
        title: r.title, handle: r.handle, image: r.image, desc: r.desc || '',
        cls: r.cls || 'default', uses: r.suitableFor || [], hasColour: colIdx >= 0,
        variants: vs,
        dias: vs.map(function (v) { return v.dia; })
               .filter(function (d, i, a) { return a.indexOf(d) === i; })
               .sort(function (a, b) { return a - b; }),
        from: vs.length ? Math.min.apply(null, vs.map(function (v) { return v.price; })) : 0,
        stock: vs.reduce(function (a, v) { return a + (v.stock > 0 ? v.stock : 0); }, 0)
      };
    }
    var ROPES = (CFG.ropes || []).map(normaliseRope).filter(function (r) { return r.variants.length; });
    if (!ROPES.length) { console.warn('[custom-build] no ropes with usable variants'); return; }

    var USES = CFG.uses || [];
    var ROPE = null, VARIANTS = [], DIAS = [];
    function ropesFor(use) {
      var m = ROPES.filter(function (r) { return !r.uses.length || r.uses.indexOf(use) !== -1; });
      return m.length ? m : ROPES;
    }
    function setRope(r) { ROPE = r; VARIANTS = r.variants; DIAS = r.dias; }

    /* ---------- services ---------- */
    var ALLSVC = (CFG.services || []).filter(function (s) { return s.active !== false; })
      .sort(function (a, b) { return (a.sort || 99) - (b.sort || 99); });
    var SVC = [], ENDS = [], EXTRAS = [], byCode = {};
    function applyUse(use) {
      SVC = ALLSVC.filter(function (s) {
        return !s.appliesTo || !s.appliesTo.length || s.appliesTo.indexOf(use) !== -1;
      });
      ENDS = SVC.filter(function (s) { return s.category === 'end_finish'; });
      EXTRAS = SVC.filter(function (s) { return s.category === 'extra'; });
      byCode = {}; SVC.forEach(function (s) { byCode[s.code] = s; });
    }

    /* ---------- prices come from the variants ----------
       The metaobject stores WHICH variant a service maps to; price and
       availability are read from that variant, which is what Shopify charges. */
    var SVCV = {}, HAVE_SVCV = false;
    (function () {
      var sv = CFG.serviceVariants;
      if (!sv) return;
      if (!Object.keys(sv).length) return;
      SVCV = sv; HAVE_SVCV = true;
    })();

    function svcBand(map) {
      if (!map || typeof map !== 'object') return null;
      var cls = ROPE && ROPE.cls;
      if (cls && map[cls] && typeof map[cls] === 'object') return map[cls];
      if (map['default'] && typeof map['default'] === 'object') return map['default'];
      return map;
    }
    function svcVariant(s, dia) {
      var m = svcBand(s && s.variants); if (!m) return null;
      var v = m[String(dia)]; if (v === undefined) v = m.any;
      return v || null;
    }
    function svcPrice(s, dia) {
      var vid = svcVariant(s, dia);
      if (HAVE_SVCV && vid && SVCV[vid] && SVCV[vid].price != null) return Number(SVCV[vid].price) || 0;
      var m = svcBand(s && s.prices); if (!m) return 0;
      var p = m[String(dia)]; if (p === undefined) p = m.any;
      return Number(p) || 0;
    }
    function offerable(s, dia) {
      var vid = svcVariant(s, dia);
      if (vid) {
        if (!HAVE_SVCV) return true;
        return !!SVCV[vid] && SVCV[vid].available !== false;
      }
      var m = svcBand(s && s.prices);
      return !m || !Object.keys(m).length;
    }
    function endsFor(end) {
      return ENDS.filter(function (s) {
        if (s.ends && s.ends.length && s.ends.indexOf(end) === -1) return false;
        return offerable(s, S.dia);
      });
    }
    function extrasFor() {
      return EXTRAS.filter(function (s) { return offerable(s, S.dia); });
    }

    /* ---------- state ---------- */
    var S = {
      use: null, rope: null, dia: null, colour: null,
      len: Math.max(SET.minLength, Math.min(SET.maxLength, SET.defaultLength)),
      activeEnd: 'A', ends: { A: null, B: null }, extras: {}, boat: '', mark: ''
    };
    function colsFor(d) { return VARIANTS.filter(function (v) { return v.dia === d; }); }
    /* Every colour the rope is made in, in catalogue order — not only the ones
       that exist at the diameter currently selected. */
    function coloursOf() {
      var seen = {}, out = [];
      for (var i = 0; i < VARIANTS.length; i++) {
        var c = VARIANTS[i].colour;
        if (!seen[c]) { seen[c] = 1; out.push(c); }
      }
      return out;
    }
    /* "14, 18, 20 mm only" — or "14 mm and up" once the list gets long. */
    function diaHint(colour) {
      var ds = [];
      for (var i = 0; i < VARIANTS.length; i++)
        if (VARIANTS[i].colour === colour && ds.indexOf(VARIANTS[i].dia) === -1) ds.push(VARIANTS[i].dia);
      ds.sort(function (a, b) { return a - b; });
      if (!ds.length) return 'Not available';
      if (ds.length > 4) return ds[0] + ' mm and up';
      return ds.join(', ') + ' mm only';
    }

    function pref(list, want) {
      for (var i = 0; i < want.length; i++)
        for (var j2 = 0; j2 < list.length; j2++) if (list[j2].code === want[i]) return list[j2].code;
      return list.length ? list[list.length - 1].code : null;
    }
    var END_PREFS = {
      mooring:        { A: ['loop250web', 'loop250', 'eyess'], B: ['backsplice', 'whip', 'heatseal'] },
      anchoring:      { A: ['eyess', 'eyenyl', 'loop250'],     B: ['backsplice', 'whip', 'heatseal'] },
      towing:         { A: ['loop250', 'eyess'],               B: ['loop250', 'backsplice', 'whip'] },
      'sail-control': { A: ['eyess', 'eye30', 'whip'],         B: ['whiptail', 'whip', 'heatseal'] },
      'mast-rigging': { A: ['eyesnap', 'eyess', 'eye30'],      B: ['whiptail', 'whip', 'heatseal'] },
      'deck-safety':  { A: ['eyess', 'eye30', 'whip'],         B: ['backsplice', 'whip', 'heatseal'] }
    };
    function seedEnds() {
      var p = END_PREFS[S.use] || END_PREFS['sail-control'];
      S.ends.A = pref(endsFor('A'), p.A);
      S.ends.B = pref(endsFor('B'), p.B);
    }
    function seedRope(r) {
      setRope(r);
      S.rope = r.handle;
      var want = DIAS.indexOf(10) !== -1 ? 10 : DIAS[Math.min(2, DIAS.length - 1)];
      S.dia = DIAS.indexOf(S.dia) !== -1 ? S.dia : want;
      var cs = colsFor(S.dia);
      if (!cs.some(function (v) { return v.colour === S.colour; })) S.colour = cs.length ? cs[0].colour : null;
      Object.keys(S.extras).forEach(function (c) { if (!byCode[c] || !offerable(byCode[c], S.dia)) delete S.extras[c]; });
      seedEnds();
    }
    function seedUse(use) {
      S.use = use;
      applyUse(use);
      var list = ropesFor(use);
      var keep = list.filter(function (r) { return r.handle === S.rope; })[0];
      seedRope(keep || list[0]);
    }
    /* Deep link from a rope product page: ?rope=<handle>&len=<metres>
       Set BEFORE seedUse: seedUse's own `keep` lookup honours a pre-set S.rope,
       and the `elLen.value = S.len` assignment further down picks up S.len.
       An unknown handle is ignored on purpose — the builder opens normally. */
    var fxQ = null;
    try { fxQ = new URLSearchParams(window.location.search); } catch (e) { fxQ = null; }
    var fxUse = (USES[0] && USES[0].code) || 'mooring';
    if (fxQ) {
      var fxH = fxQ.get('rope');
      if (fxH) {
        var fxR = ROPES.filter(function (r) { return r.handle === fxH; })[0];
        if (fxR) {
          S.rope = fxR.handle;
          /* Step 2 only lists ropes matching the current use, so pick a use this
             rope is actually filed under. Empty uses = shows everywhere. */
          if (fxR.uses && fxR.uses.length) {
            var fxU = USES.filter(function (u) { return fxR.uses.indexOf(u.code) !== -1; })[0];
            if (fxU) { fxUse = fxU.code; }
          }
        }
      }
      var fxL = parseInt(fxQ.get('len'), 10);
      if (!isNaN(fxL)) { S.len = Math.max(SET.minLength, Math.min(SET.maxLength, fxL)); }
    }
    seedUse(fxUse);

    function variant() {
      var m = VARIANTS.filter(function (v) { return v.dia === S.dia && v.colour === S.colour; });
      return m[0] || colsFor(S.dia)[0] || VARIANTS[0];
    }
    function buildLabel() {
      for (var i = 0; i < USES.length; i++) if (USES[i].code === S.use) return USES[i].build;
      return 'Custom build';
    }
    function buildId() {
      var seed = S.use + '|' + S.rope + '|' + S.dia + '|' + S.colour + '|' + S.len + '|' + S.ends.A + '|' + S.ends.B;
      var h = 7; for (var i = 0; i < seed.length; i++) h = (h * 33 + seed.charCodeAt(i)) >>> 0;
      return 'FX-' + h.toString(36).toUpperCase().slice(0, 6);
    }

    /* dom refs */
    var $ = function (sel) { return root.querySelector(sel); };
    var elUses = $('[data-cb-uses]'), elRopes = $('[data-cb-ropes]'), elColWrap = $('[data-cb-colwrap]');
    var elDia = $('[data-cb-dia]'), elCol = $('[data-cb-col]'), elStock = $('[data-cb-stocknote]');
    var elLen = $('[data-cb-len]'), elEnds = $('[data-cb-ends]'), elExtras = $('[data-cb-extras]');
    var elSpec = $('[data-cb-spec]'), elTotal = $('[data-cb-total]'), elTotalEx = $('[data-cb-totalex]');
    var elLead = $('[data-cb-lead]'), elAdd = $('[data-cb-add]'), elTip = $('[data-cb-tip]');
    var elPreview = $('[data-cb-preview]');
    var elEndLabel = $('[data-cb-endlabel]'), elRopeBar = $('[data-cb-ropebar]'), elLenLabel = $('[data-cb-lenlabel]');

    elLen.value = S.len;
    elLen.min = SET.minLength; elLen.max = SET.maxLength;
    $('[data-cb-endalabel]').textContent = SET.endALabel.toUpperCase();
    $('[data-cb-endblabel]').textContent = SET.endBLabel.toUpperCase();

    /* ---------- render ---------- */
    function renderUses() {
      if (!elUses) return;
      elUses.innerHTML = USES.map(function (u) {
        var n = ROPES.filter(function (r) { return r.uses.indexOf(u.code) !== -1; }).length;
        return '<button type="button" class="cb-opt-btn' + (u.code === S.use ? ' cb-sel' : '') + '" data-use="' + esc(u.code) + '">' +
          '<span class="cb-t">' + esc(u.label) + '</span>' +
          '<span class="cb-d">' + esc(u.hint || '') + '</span>' +
          '<span class="cb-p">' + (n ? n + (n === 1 ? ' rope' : ' ropes') : 'ask us') + '</span></button>';
      }).join('');
    }
    function renderRopes() {
      if (!elRopes) return;
      var list = ropesFor(S.use);
      elRopes.innerHTML = list.map(function (r) {
        var d = r.dias, span = d.length ? d[0] + '–' + d[d.length - 1] + ' mm' : '';
        var cls = r.stock <= 0 ? 'cb-none' : (r.stock < 100 ? 'cb-low' : 'cb-ok2');
        var txt = r.stock <= 0 ? 'To order' : r.stock + ' m in stock';
        return '<button type="button" class="cb-opt-btn cb-ropecard-btn' + (r.handle === S.rope ? ' cb-sel' : '') + '" data-rope="' + esc(r.handle) + '">' +
          (r.image ? '<span class="cb-rthumb"><img src="' + esc(r.image) + '" alt="" loading="lazy"></span>' : '') +
          '<span class="cb-rbody">' +
            '<span class="cb-t">' + esc(r.title) + '</span>' +
            (r.desc ? '<span class="cb-rdesc">' + esc(r.desc) + '</span>' : '') +
            '<span class="cb-rmeta">' +
              '<span class="cb-p">' + esc(span) + '</span>' +
              '<span class="cb-p">from ' + money(r.from) + ' / m</span>' +
              '<span class="cb-stock ' + cls + '"><span class="cb-dot"></span>' + txt + '</span>' +
            '</span>' +
          '</span></button>';
      }).join('');
    }
    function renderDias() {
      elDia.innerHTML = DIAS.map(function (d) {
        return '<button type="button" class="cb-opt-btn' + (d === S.dia ? ' cb-sel' : '') + '" data-dia="' + d + '">' +
          '<span class="cb-t">' + d + ' mm</span><span class="cb-p">from ' + money(Math.min.apply(null, colsFor(d).map(function (x) { return x.price; }))) + ' / m</span></button>';
      }).join('');
    }
    /* Colour step.

       Two rules, both learned the hard way:

       1. If the rope has a colour option, the step is always shown — even when
          the rope only comes in one colour. A step that appears for one rope
          and silently vanishes for the next reads as a fault.
       2. Every colour the rope is made in is listed, not only the ones that
          exist at the chosen diameter. Squareline is White up to 12 mm and
          White or Navy from 14 mm; listing only what fits the current size
          meant a customer at 10 mm never learned Navy existed. Colours that do
          not come in the chosen diameter are shown greyed, with the sizes they
          do come in. */
    function renderCols() {
      var all = coloursOf();
      if (elColWrap) elColWrap.hidden = !ROPE.hasColour;
      var here = colsFor(S.dia);
      elCol.innerHTML = all.map(function (name) {
        var v = null, i;
        for (i = 0; i < here.length; i++) if (here[i].colour === name) { v = here[i]; break; }
        if (!v) {
          var any = null;
          for (i = 0; i < VARIANTS.length; i++) if (VARIANTS[i].colour === name) { any = VARIANTS[i]; break; }
          return '<button type="button" class="cb-opt-btn cb-off" disabled aria-disabled="true">' +
            '<span class="cb-sw" style="background:' + (any ? any.hex.css : '#9AA3AB') + '"></span>' +
            '<span class="cb-t">' + esc(name) + '</span>' +
            '<span class="cb-stock cb-none"><span class="cb-dot"></span>' + diaHint(name) + '</span></button>';
        }
        var cls = !v.available || v.stock <= 0 ? 'cb-none' : (v.stock < 60 ? 'cb-low' : 'cb-ok2');
        var txt = !v.available || v.stock <= 0 ? 'On order' : v.stock + ' m on the reel';
        return '<button type="button" class="cb-opt-btn' + (v.colour === S.colour ? ' cb-sel' : '') + '" data-col="' + esc(v.colour) + '">' +
          '<span class="cb-sw" style="background:' + v.hex.css + '"></span>' +
          '<span class="cb-t">' + esc(v.colour) + '</span>' +
          '<span class="cb-p">' + money(v.price) + ' / m</span>' +
          '<span class="cb-stock ' + cls + '"><span class="cb-dot"></span>' + txt + '</span></button>';
      }).join('');
    }
    function renderStock() {
      var v = variant(), h = '';
      if (!v) { elStock.innerHTML = ''; return; }
      if (!v.available || v.stock <= 0) {
        h = '<div class="cb-note cb-bad2"><b>Not on the shelf.</b> We\'ll order this reel in — allow about ' + SET.leadDaysSlow + ' working days in total.</div>';
      } else if (S.len > v.stock) {
        h = '<div class="cb-note cb-warn2"><b>' + S.len + ' m needed, ' + v.stock + ' m on the reel.</b> We can still build it, but we\'ll need to order in — allow about ' + SET.leadDaysSlow + ' working days.</div>';
      } else if (S.len > v.stock * 0.6) {
        h = '<div class="cb-note cb-info">This will use most of the reel (' + S.len + ' m of ' + v.stock + ' m). Still fine to order.</div>';
      }
      elStock.innerHTML = h;
    }
    function renderEnds() {
      var v = variant(), hex = v ? v.hex.solid : '#2C5F9E';
      elEndLabel.textContent = S.activeEnd === 'A' ? SET.endALabel : SET.endBLabel;
      var avail = endsFor(S.activeEnd);
      var priced = avail.filter(function (s) { return svcVariant(s, S.dia); });
      elEnds.innerHTML = (priced.length ? '' :
        '<div class="cb-note cb-warn2" style="grid-column:1/-1"><b>Splicing at ' + S.dia +
        ' mm is quoted individually.</b> We can cut and seal this length now, or call our Rigging Department and we\'ll price the splice for you.</div>') +
        avail.map(function (s) {
        var p = svcPrice(s, S.dia);
        return '<button type="button" class="cb-opt-btn' + (S.ends[S.activeEnd] === s.code ? ' cb-sel' : '') + '" data-end-opt="' + esc(s.code) + '">' +
          '<span class="cb-thumb">' + art(s.code, hex, uid) + '</span>' +
          '<span class="cb-i" data-tip="' + esc(s.code) + '" role="button" tabindex="0" aria-label="More about ' + esc(s.name) + '">i</span>' +
          '<span class="cb-t">' + esc(s.name) + '</span>' +
          '<span class="cb-d">' + esc(s.short) + '</span>' +
          '<span class="cb-p' + (p === 0 ? ' cb-free' : '') + '">' + (p === 0 ? 'Included' : '+ ' + money(p)) + '</span></button>';
      }).join('');

      ['A', 'B'].forEach(function (e) {
        var s = byCode[S.ends[e]], p = s ? svcPrice(s, S.dia) : 0;
        var t = $('[data-cb-end' + e.toLowerCase() + 'txt]'), pr = $('[data-cb-end' + e.toLowerCase() + 'price]');
        t.textContent = s ? (s.name.length > 24 ? s.name.slice(0, 22) + '…' : s.name) : 'Not set';
        pr.textContent = s ? (p === 0 ? 'included' : '+ ' + money(p)) : '';
        var g = root.querySelector('[data-cb-end="' + e + '"]');
        if (g) g.classList.toggle('cb-active', S.activeEnd === e);
      });
      if (elRopeBar) elRopeBar.setAttribute('fill', hex);
      if (elLenLabel) elLenLabel.textContent = S.len + ' m';
    }
    function renderExtras() {
      var v = variant(), hex = v ? v.hex.solid : '#2C5F9E';
      elExtras.innerHTML = extrasFor().map(function (s) {
        var on = S.extras[s.code] !== undefined, q = S.extras[s.code] || 1;
        var p = svcPrice(s, S.dia);
        var lbl = p === 0 ? 'Included' : (s.unit === 'metre' ? '+ ' + money(p) + ' / m' : '+ ' + money(p));
        return '<button type="button" class="cb-opt-btn' + (on ? ' cb-sel' : '') + '" data-extra="' + esc(s.code) + '">' +
          '<span class="cb-thumb">' + art(s.code, hex, uid) + '</span>' +
          '<span class="cb-i" data-tip="' + esc(s.code) + '" role="button" tabindex="0" aria-label="More about ' + esc(s.name) + '">i</span>' +
          '<span class="cb-t">' + esc(s.name) + '</span>' +
          '<span class="cb-d">' + esc(s.short) + '</span>' +
          '<span class="cb-p' + (p === 0 ? ' cb-free' : '') + '">' + lbl + '</span>' +
          (on && s.unit === 'metre'
            ? '<span class="cb-stock" onclick="event.stopPropagation()">Length: <input type="number" min="1" max="' + (s.max || 5) +
              '" value="' + q + '" data-extra-qty="' + esc(s.code) + '" style="width:58px;margin:0 4px;padding:4px;border:1px solid #D3DDE6;border-radius:6px;text-align:center"> m</span>'
            : '') +
          '</button>';
      }).join('');
    }

    /* ---------- cart lines ---------- */
    function lines() {
      var v = variant(); if (!v) return [];
      var bid = buildId(), out = [];
      var props = {
        'Build': buildLabel(),
        'Rope': ROPE.title + ' — ' + S.dia + ' mm' + (S.colour ? ' ' + S.colour : ''),
        'Length': S.len + ' m'
      };
      props[SET.endALabel] = byCode[S.ends.A] ? byCode[S.ends.A].name : '—';
      props[SET.endBLabel] = byCode[S.ends.B] ? byCode[S.ends.B].name : '—';
      if (S.boat) props['Boat'] = S.boat;
      if (S.mark) props['Line marking'] = S.mark;
      var priv = { _build_id: bid, _build_type: S.use, _rope_variant: String(v.id), _lead_days: String(SET.leadDays) };

      out.push({
        id: v.id, qty: S.len, unit: v.price, sku: v.sku,
        title: ROPE.title + ' — ' + S.dia + ' mm' + (S.colour ? ' ' + S.colour : ''),
        sub: S.len + ' m × ' + money(v.price) + '/m',
        props: Object.assign({}, props, priv)
      });

      ['A', 'B'].forEach(function (e) {
        var s = byCode[S.ends[e]]; if (!s) return;
        var vid = svcVariant(s, S.dia); if (!vid) return;
        out.push({
          id: Number(vid), qty: 1, unit: svcPrice(s, S.dia), sku: s.code,
          title: s.name + ' — ' + S.dia + ' mm', sub: e === 'A' ? SET.endALabel : SET.endBLabel,
          props: { 'Build': buildLabel(), 'Applies to': (e === 'A' ? SET.endALabel : SET.endBLabel), _build_id: bid, _service: s.code }
        });
      });

      Object.keys(S.extras).forEach(function (code) {
        var s = byCode[code]; if (!s) return;
        var p = svcPrice(s, S.dia); if (!p) return;
        var vid = svcVariant(s, S.dia); if (!vid) return;
        var q = S.extras[code] || 1;
        out.push({
          id: Number(vid), qty: q, unit: p, sku: s.code, title: s.name,
          sub: s.unit === 'metre' ? q + ' m × ' + money(p) + '/m' : (q > 1 ? q + ' × ' + money(p) : ''),
          props: { 'Build': buildLabel(), _build_id: bid, _service: s.code }
        });
      });
      return out;
    }

    function renderSummary() {
      var L = lines();
      var total = L.reduce(function (a, l) { return a + l.unit * l.qty; }, 0);
      var html = L.map(function (l) {
        return '<div class="cb-row"><span class="cb-k"><b>' + esc(l.title) + '</b>' + esc(l.sub) + '</span>' +
               '<span class="cb-v">' + money(l.unit * l.qty) + '</span></div>';
      }).join('');
      Object.keys(S.extras).forEach(function (code) {
        var s = byCode[code]; if (!s || svcPrice(s, S.dia)) return;
        html += '<div class="cb-row"><span class="cb-k"><b>' + esc(s.name) + '</b>no charge</span><span class="cb-v cb-free">Included</span></div>';
      });
      if (S.boat || S.mark) {
        html += '<div class="cb-row"><span class="cb-k"><b>Marked</b>' + esc([S.boat, S.mark].filter(Boolean).join(' · ')) + '</span><span class="cb-v">—</span></div>';
      }
      elSpec.innerHTML = html || '<p class="cb-muted">Nothing selected yet.</p>';
      elTotal.textContent = money(total);
      elTotalEx.textContent = 'ex VAT ' + money(total / 1.2);

      var v = variant(), slow = !v || !v.available || v.stock <= 0 || S.len > v.stock;
      elLead.textContent = slow
        ? '⏱ Rope to order — allow about ' + SET.leadDaysSlow + ' working days'
        : '⏱ Made to order — allow ' + SET.leadDays + ' working days';
      elAdd.disabled = !(S.ends.A && S.ends.B && S.len > 0 && v);
    }

    /* ---------- finished-line preview ---------- */
    function previewSVG() {
      var v = variant(), hex = v ? v.hex.solid : '#2C5F9E';
      var a = byCode[S.ends.A], b = byCode[S.ends.B];

      var W = 760, EW = 300, EH = 102.9;
      var TOP = 26, RY = TOP + 50.7, RH = 21.4, RT = RY - RH / 2;
      var w = 'cbpw-' + uid;

      function endArt(code, mirror) {
        var inner = '<svg x="0" y="' + TOP + '" width="' + EW + '" height="' + EH + '" viewBox="0 16 210 72" preserveAspectRatio="none">' +
                    art(code, hex, uid + (mirror ? 'r' : 'l')) + '</svg>';
        return mirror ? '<g transform="translate(' + W + ',0) scale(-1,1)">' + inner + '</g>' : inner;
      }

      var out = '<svg viewBox="0 0 ' + W + ' 206" role="img" aria-label="Preview of your finished line">' +
        '<defs><pattern id="' + w + '" width="14" height="14" patternUnits="userSpaceOnUse" patternTransform="rotate(32)">' +
        '<path d="M0 7 H14" stroke="rgba(0,0,0,.16)" stroke-width="3"/></pattern></defs>';

      out += '<rect x="' + (EW - 10) + '" y="' + RT + '" width="' + (W - 2 * EW + 20) + '" height="' + RH + '" fill="' + hex + '"/>' +
             '<rect x="' + (EW - 10) + '" y="' + RT + '" width="' + (W - 2 * EW + 20) + '" height="' + RH + '" fill="url(#' + w + ')"/>';

      var cx = W / 2;
      if (S.extras.hose !== undefined) {
        out += '<rect x="' + (cx - 75) + '" y="' + (RT - 4) + '" width="150" height="' + (RH + 8) + '" rx="' + (RH / 2 + 4) +
               '" fill="#CFE0EA" opacity=".85" stroke="#9FB6C4" stroke-width="1.3"/>';
      }
      if (S.extras.chafe !== undefined) {
        var off = S.extras.hose !== undefined ? 95 : 0;
        out += '<rect x="' + (cx - 60 - off) + '" y="' + (RT - 2) + '" width="120" height="' + (RH + 4) + '" rx="' + (RH / 2 + 2) +
               '" fill="#8A939E"/><rect x="' + (cx - 60 - off) + '" y="' + (RT - 2) + '" width="120" height="' + (RH + 4) +
               '" rx="' + (RH / 2 + 2) + '" fill="url(#' + w + ')"/>';
      }
      if (S.extras.snubber !== undefined) {
        out += '<rect x="' + (cx + 96) + '" y="' + (RT - 13) + '" width="74" height="' + (RH + 26) + '" rx="14" fill="#2A2E33"/>' +
               '<rect x="' + (cx + 118) + '" y="' + (RT - 15) + '" width="2.5" height="' + (RH + 30) + '" fill="rgba(255,255,255,.14)"/>' +
               '<rect x="' + (cx + 146) + '" y="' + (RT - 15) + '" width="2.5" height="' + (RH + 30) + '" fill="rgba(255,255,255,.14)"/>' +
               '<rect x="' + (cx + 90) + '" y="' + RT + '" width="86" height="' + RH + '" fill="' + hex + '"/>' +
               '<rect x="' + (cx + 90) + '" y="' + RT + '" width="86" height="' + RH + '" fill="url(#' + w + ')"/>';
      }
      if (S.extras.colmark !== undefined) {
        for (var i = 0; i < 3; i++)
          out += '<rect x="' + (cx - 150 + i * 9) + '" y="' + (RT - 1) + '" width="5" height="' + (RH + 2) + '" rx="1.6" fill="#C8342E"/>';
      }

      out += endArt(a ? a.code : 'heatseal', false) + endArt(b ? b.code : 'heatseal', true);

      var DY = 152;
      out += '<line x1="40" y1="' + DY + '" x2="' + (W - 40) + '" y2="' + DY + '" stroke="#93A0AD"/>' +
             '<line x1="40" y1="' + (DY - 6) + '" x2="40" y2="' + (DY + 6) + '" stroke="#93A0AD"/>' +
             '<line x1="' + (W - 40) + '" y1="' + (DY - 6) + '" x2="' + (W - 40) + '" y2="' + (DY + 6) + '" stroke="#93A0AD"/>' +
             '<rect x="' + (W / 2 - 46) + '" y="' + (DY - 13) + '" width="92" height="26" rx="13" fill="#fff"/>' +
             '<text x="' + (W / 2) + '" y="' + (DY + 5) + '" text-anchor="middle" font-size="15" font-weight="700" fill="#00254E">' +
             S.len + ' m</text>';

      function cap(x, anchor, label, s) {
        var n = s ? s.name : 'Not set';
        if (n.length > 30) n = n.slice(0, 28) + '…';
        return '<text x="' + x + '" y="182" text-anchor="' + anchor + '" font-size="11" font-weight="700" fill="#5A7186" letter-spacing=".07em">' +
               esc(label.toUpperCase()) + '</text>' +
               '<text x="' + x + '" y="197" text-anchor="' + anchor + '" font-size="12.5" fill="#00254E">' + esc(n) + '</text>';
      }
      out += cap(40, 'start', SET.endALabel, a) + cap(W - 40, 'end', SET.endBLabel, b);

      if (S.boat || S.mark) {
        out += '<text x="' + (W / 2) + '" y="16" text-anchor="middle" font-size="12.5" fill="#5A7186">' +
               esc([S.boat, S.mark].filter(Boolean).join(' · ')) + '</text>';
      }
      return out + '</svg>';
    }

    function renderPreview() {
      if (elPreview) elPreview.innerHTML = previewSVG();
    }

    function renderAll() {
      renderUses(); renderRopes(); renderDias(); renderCols(); renderStock(); renderEnds(); renderExtras(); renderPreview(); renderSummary();
    }

    /* ---------- tooltips ---------- */
    var tipCode = null, hideT;
    function showTip(el) {
      var s = byCode[el.getAttribute('data-tip')]; if (!s) return;
      var p = svcPrice(s, S.dia);
      elTip.innerHTML = '<h4>' + esc(s.name) + '</h4><p>' + esc(s.desc) + '</p>' +
        (s.best ? '<span class="cb-best"><b>Best for:</b> ' + esc(s.best) + '</span>' : '') +
        '<span class="cb-specline">' + esc(s.spec || '') + (p ? ' · ' + money(p) + ' at ' + S.dia + ' mm' : '') + '</span>';
      elTip.hidden = false; tipCode = el.getAttribute('data-tip');
      var r = el.getBoundingClientRect(), rr = root.getBoundingClientRect();
      var left = r.left - rr.left + r.width / 2 - 160;
      left = Math.max(8, Math.min(left, root.offsetWidth - 328));
      var top = r.bottom - rr.top + 8;
      if (r.bottom + elTip.offsetHeight + 20 > window.innerHeight) top = r.top - rr.top - elTip.offsetHeight - 8;
      elTip.style.left = left + 'px'; elTip.style.top = Math.max(0, top) + 'px';
    }
    function hideTip() { elTip.hidden = true; tipCode = null; }

    root.addEventListener('mouseover', function (e) {
      var i = e.target.closest('[data-tip]');
      if (i) { clearTimeout(hideT); if (tipCode !== i.getAttribute('data-tip')) showTip(i); return; }
      if (e.target.closest('[data-cb-tip]')) { clearTimeout(hideT); return; }
      clearTimeout(hideT); hideT = setTimeout(hideTip, 220);
    });

    /* ---------- interaction ---------- */
    root.addEventListener('click', function (e) {
      var i = e.target.closest('[data-tip]');
      if (i) { e.preventDefault(); e.stopPropagation(); tipCode === i.getAttribute('data-tip') ? hideTip() : showTip(i); return; }
      if (e.target.closest('[data-cb-tip]')) return;

      var g = e.target.closest('[data-cb-end]');
      if (g) { S.activeEnd = g.getAttribute('data-cb-end'); renderAll(); return; }

      var b = e.target.closest('button'); if (!b) return;

      if (b.hasAttribute('data-use')) {
        var u = b.getAttribute('data-use');
        if (u !== S.use) { seedUse(u); renderAll(); }
        return;
      }
      if (b.hasAttribute('data-rope')) {
        var h = b.getAttribute('data-rope');
        var rp = ROPES.filter(function (x) { return x.handle === h; })[0];
        if (rp && h !== S.rope) { S.dia = null; S.colour = null; seedRope(rp); renderAll(); }
        return;
      }

      if (b.hasAttribute('data-dia')) {
        S.dia = parseFloat(b.getAttribute('data-dia'));
        var cs = colsFor(S.dia);
        if (!cs.some(function (v) { return v.colour === S.colour; })) S.colour = cs.length ? cs[0].colour : null;
        var a = endsFor('A'), bb = endsFor('B');
        if (!a.some(function (s) { return s.code === S.ends.A; })) S.ends.A = pref(a, (END_PREFS[S.use] || {}).A || []);
        if (!bb.some(function (s) { return s.code === S.ends.B; })) S.ends.B = pref(bb, (END_PREFS[S.use] || {}).B || []);
        Object.keys(S.extras).forEach(function (c) { if (!byCode[c] || !offerable(byCode[c], S.dia)) delete S.extras[c]; });
        renderAll(); return;
      }
      if (b.hasAttribute('data-col')) { S.colour = b.getAttribute('data-col'); renderAll(); return; }
      if (b.hasAttribute('data-end-opt')) { S.ends[S.activeEnd] = b.getAttribute('data-end-opt'); renderAll(); return; }
      if (b.hasAttribute('data-extra')) {
        var code = b.getAttribute('data-extra'), s = byCode[code];
        if (S.extras[code] !== undefined) delete S.extras[code];
        else S.extras[code] = (s && s.unit === 'metre') ? 2 : 1;
        renderAll(); return;
      }
      if (b.hasAttribute('data-cb-len-up')) { S.len = Math.min(SET.maxLength, S.len + 1); elLen.value = S.len; renderAll(); return; }
      if (b.hasAttribute('data-cb-len-down')) { S.len = Math.max(SET.minLength, S.len - 1); elLen.value = S.len; renderAll(); return; }
      if (b.hasAttribute('data-cb-add')) { addToCart(b); return; }
    });

    root.addEventListener('input', function (e) {
      var t = e.target;
      if (t.hasAttribute('data-cb-len')) {
        var n = parseInt(t.value, 10);
        S.len = isNaN(n) ? SET.minLength : Math.max(SET.minLength, Math.min(SET.maxLength, n));
        renderStock(); renderEnds(); renderPreview(); renderSummary(); return;
      }
      if (t.hasAttribute('data-cb-boat')) { S.boat = t.value; renderPreview(); renderSummary(); return; }
      if (t.hasAttribute('data-cb-mark')) { S.mark = t.value; renderPreview(); renderSummary(); return; }
      if (t.hasAttribute('data-extra-qty')) {
        var c = t.getAttribute('data-extra-qty'), s = byCode[c];
        var q = parseInt(t.value, 10) || 1;
        S.extras[c] = Math.max(1, Math.min((s && s.max) || 5, q));
        renderSummary(); return;
      }
    });

    /* ---------- add to cart ---------- */
    function addToCart(btn) {
      var L = lines(); if (!L.length) return;
      var payload = { items: L.map(function (l) { return { id: l.id, quantity: l.qty, properties: l.props }; }) };
      var original = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding…';

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body && res.body.description ? res.body.description : 'Could not add to basket');
          btn.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cb:added', { detail: res.body }));
          try {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
          } catch (e) {}
          setTimeout(function () { window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart'; }, 500);
        })
        .catch(function (err) {
          console.error('[custom-build]', err);
          btn.textContent = 'Could not add — try again';
          setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2500);
        });
    }

    renderAll();
  }

  function boot() {
    document.querySelectorAll('[data-cb-root]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
